import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { Router } from "@angular/router";
import { setStorageBackRoute } from "@common/directive/storage-back-route.util";

@Directive({
  selector: '[storeBackRoute]',
  standalone: true
})
export class StoreBackRouteDirective {

  @Input() routerLink: any;

  constructor(private router: Router, private el: ElementRef) {}

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    setStorageBackRoute(this.router, this.routerLink);
  }
}
